import { customElement } from "lit/decorators.js";
import { LitElement } from "lit";
import { SlhCoreFormValidationObserver } from "@slhuicore/form-validation-observer";

@customElement("slh-form-validation-observer")
export default class SlhFormValidationObserver extends SlhCoreFormValidationObserver(
  LitElement
) {}
